/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.coupons.categories.controllers', [
    'ui.router',
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.permissions',
    'acme.view.application.coupons.categories.createModal.controllers',
    'acme.view.application.coupons.categories.removeModal.controllers',
    'acme.common.factory.gridState'
])

.controller('CouponsCategoriesController', ['$scope', '$state', '$timeout', '$filter', '$uibModal', 'ApiService', 'PermissionsService', 'GridStateFactory', function($scope, $state, $timeout, $filter, $uibModal, ApiService, PermissionsService, GridStateFactory) {

    $scope.couponsCategories = {

      model: [],
      searchQuery: '',
      filtered: [],
      isUpdating: false,
      isLoaded: false,

      gridState: new GridStateFactory(),

      grid: {
        pageSize: 50,
        paginate: true,
        multiselect: false,
        enableRowSelection: false,
        showFooter: true,
        useExternalPagination: true,
        useExternalSorting: true,
        columns: [
          {
              field: 'id',
              displayName: 'ID',
              visible: false
          },
          {
              field: 'name',
              displayName: 'name'
          },
          {
              field: 'description',
              displayName: 'description'
          }
        ]
      },

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Categories',
          buttonRight: {
            label: '+ Create Category',
            permissions: 'COUPON_CATEGORIES_CREATE',
            action: function () {
              $scope.couponsCategories.create();
            }
          }
        });

        this.gridState.updateGridState(null, this.grid.pageSize, 'name');

        this.getCouponsCategories();

        if (PermissionsService.check('COUPON_CATEGORIES_DELETE')) {
          $scope.couponsCategories.grid.columns.push({
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.couponsCategories.remove(row.entity.id);
            },
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only"> - Opens Dialog</span></a></div>'
          });
        }

        if (PermissionsService.check('COUPON_CATEGORIES_UPDATE')) {
          $scope.couponsCategories.grid.columns.unshift({
            field: 'edit',
            displayName: 'Edit',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.couponsCategories.gridDoubleClick(row);
            },
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onGridDblClick(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>'
          });
        }
      },

      findCategory: function(id) {
        var i, ii,
          r = false;

        for (i=0,ii=$scope.couponsCategories.model.length;i<ii;i++) {
          if ($scope.couponsCategories.model[i].id === id) {
            r = {
              index: i,
              item: $scope.couponsCategories.model[i]
            };
            break;
          }
        }

        return r;
      },

      search: function() {
        this.filtered = $filter('filter')(this.model, function(category) {
            var name = category.name || '',
                description = category.description || '',
                value = (name + description).toLowerCase();

            return (value.indexOf($scope.couponsCategories.searchQuery.toLowerCase()) !== -1) ? category : null;
        });
        console.log('CouponsCategoriesController::search', this.filtered.length);
      },

      getCouponsCategories: function() {
        ApiService.coupons.categories.list(this.gridState.getGridState()).then(this.success.getCouponsCategories, this.error.getCouponsCategories);
      },

      create: function(){
        var self = $scope.couponsCategories;
        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/coupons/categories/modals/createCouponsCategory.tpl.html',
          size: 'lg',
          controller: 'CreateCouponsCategoryModalController',
          resolve: {
            category: function() {
              return self.model;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (category) {
          self.isUpdating = true;
          ApiService.coupons.categories.create(category).then(self.success.create, self.error.create);
        }, function () {
          // Do nothing
        });
      },

      remove: function(id){
        var self = $scope.couponsCategories;
        self.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/coupons/categories/modals/removeCouponsCategory.tpl.html',
          size: 'lg',
          controller: 'RemoveCouponsCategoryModalController',
          resolve: {
            currentCategory: function() {
              return self.findCategory(id).item;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.removeModal.result.then(function (category) {
          self.isUpdating = true;

          ApiService.coupons.categories.remove(id).then(function(response) {
            self.success.remove(response);
            self.model.splice(self.findCategory(id).index, 1);
            self.search();
          }, self.error.remove);
        }, function () {
          // Do nothing
        });
      },

      success: {
        init: function(response) {},

        getCouponsCategories: function(response) {
          var self = $scope.couponsCategories;
          self.model = response.data.payload.list;
          self.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
          self.search();
          self.isLoaded = true;
        },

        create: function(response) {
          var self = $scope.couponsCategories;
          self.model.push(response.data.payload);
          $timeout(function() {
            self.isUpdating = false;
            self.search();
          }, 500);
        },

        remove: function(response) {
          $timeout(function() {
            $scope.couponsCategories.isUpdating = false;
          }, 500);
        }
      },

      error: {
        init: function(response) {},

        getCouponsCategories: function(response){},

        create: function(response){
          $timeout(function() {
            $scope.couponsCategories.isUpdating = false;
          }, 500);
        },

        update: function(response){
          $timeout(function() {
            $scope.couponsCategories.isUpdating = false;
          }, 500);
        },

        remove: function(response){
          $timeout(function() {
            $scope.couponsCategories.isUpdating = false;
          }, 500);
        }
      },

      gridDoubleClick: function(item) {
        $state.go('application.coupons.categories.create', { id: item.entity.id });
      },

      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.couponsCategories;
        self.gridState.updateGridState(newPage, pageSize);
        self.getCouponsCategories();
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.couponsCategories, data = columns[0];
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getCouponsCategories();
        }
      }

    };

    $scope.couponsCategories.init();

}]);